export default {
  componentes: {},
  paineisHabilitados(ref, configuracao, acao) { // eslint-disable-line
    return {};
  },
};
